import { useRouter } from 'next/router'
import { paths } from '@mc/paths'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'
import { isQuizAllowedForSlug } from '../data/eligibility'
import { useCatalogQuizBucket } from './useExperiment'

const ENTRY_PATHNAMES = new Set([
  '/certificates/[slug]',
  '/certificates/[slug]/lesson/[lessonSlug]',
])

export const useCheckoutQuizEntry = (
  certSlug: string,
  { enabled }: { enabled: boolean },
) => {
  const { pathname } = useRouter()
  const { bucket } = useCatalogQuizBucket()
  const isEntryPoint =
    enabled && ENTRY_PATHNAMES.has(pathname) && isQuizAllowedForSlug(certSlug)

  return {
    quizHref:
      isEntryPoint && bucket === 'variant_1'
        ? paths.certificateQuiz(certSlug)
        : null,
    trackQuizExposure: () => {
      if (isEntryPoint && bucket) {
        trackExperimentViewed(EXPERIMENT_FLAG)
      }
    },
  }
}
